export default {
  loading: false,
  saving: false
}
